import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "merchantName" };
const _hoisted_2 = { class: "savingsText" };
import FavoriteChip from './FavoriteChip.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherMerchantCard',
    props: {
        logoUrl: {},
        merchantName: {},
        savingPercentage: {},
        isFavorited: { type: Boolean }
    },
    emits: ["click", "favorite-toggled"],
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, {
                class: "merchantCard",
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('click'))),
                elevation: "0",
                ripple: false
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: "imageArea",
                        style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.logoUrl + ')' })
                    }, [
                        _createVNode(FavoriteChip, {
                            isFavorited: _ctx.isFavorited,
                            onFavoriteClicked: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('favorite-toggled', $event)))
                        }, null, 8, ["isFavorited"])
                    ], 4),
                    _createVNode(_component_v_card_text, { class: "detailsArea" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.merchantName), 1),
                            _createElementVNode("div", _hoisted_2, [
                                _cache[2] || (_cache[2] = _createTextVNode("Save ")),
                                _createElementVNode("b", null, _toDisplayString(_ctx.savingPercentage) + "%", 1)
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
